import { apiConfig } from 'config';
import { swManagerRequest } from './utils';

export const getFactoryProtectedDevices = () => {
  const url = apiConfig.swManagerGetFactoryProtectedDevices();
  const options = { method: 'GET' };

  return swManagerRequest(url, options);
};
